import IEditProviderRequestModel from "interfaces/Request/IEditProviderRequestModel";
import { GlobalState } from "little-state-machine";

export const updateEditProviderRequest = (
  state: GlobalState,
  editProviderRequest: IEditProviderRequestModel
) => ({
  ...state,
  editProviderRequest
});
